export default __webpack_public_path__ + "static/img45h-90af17691d0eab6da7483ceb0854f01d.jpg";